import { ReactNode } from "react";
import { card, colors, type, fontFamily } from "../styles";
import { Freshness, FreshnessChip } from "./Pills";

/**
 * One number that matters more than the tiles around it. Used for Estimated
 * MRR, where the subtitle carrying the caveat is as load-bearing as the figure.
 */
const HeroFigure = ({
  label,
  value,
  subtitle,
  freshness,
}: {
  label: string;
  value: ReactNode;
  subtitle?: ReactNode;
  freshness: Freshness;
}) => (
  <div
    style={{
      ...card,
      padding: 20,
      display: "flex",
      flexDirection: "column",
      gap: 8,
      minWidth: 0,
    }}
  >
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8 }}>
      <div style={{ ...type.bodySmallMedium, color: colors.inkMuted }}>{label}</div>
      <FreshnessChip freshness={freshness} />
    </div>
    <div
      style={{
        fontFamily,
        fontSize: 48,
        fontWeight: 700,
        lineHeight: 1.05,
        color: colors.ink,
      }}
    >
      {value}
    </div>
    {subtitle && (
      <div style={{ ...type.bodySmallRegular, color: colors.inkFaint }}>{subtitle}</div>
    )}
  </div>
);

export default HeroFigure;
